<template>
  <v-dialog
    max-width="600"
    v-model="display"
    :persistent="busy"
  >
    <v-card v-if="display">
      <v-card-title class="subtitle-1 font-weight-light">
        Are you sure you want to remove
        <strong class="mx-1">{{ user.display_name }}</strong>
        from <strong class="ml-1">{{ seniorFunderTitles[role.title] }}</strong>?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          id="team-remove-user-cancel-btn"
          color="info"
          :disabled="busy"
          @click="() => display = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          id="team-remove-user-confirm-btn"
          color="error"
          :loading="busy"
          @click="submit"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import roleMixin from '@/mixins/roleMixin';


export default {
  name: 'AdminGroupsRemoveUserModalSeniorFunders',
  mixins: [roleMixin],
  props: {
    seniorFunder: Object,
  },
  data: () => ({
    busy: false,
    display: false,
    role: null,
    user: null,
  }),
  methods: {
    open(role, user) {
      this.role = role;
      this.user = user;
      this.display = true;
    },
    submit() {
      if (!(this.seniorFunder && this.role && this.user)) { return; }

      this.busy = true;
      const params = {
        senior_funder_id: this.seniorFunder._id,
        role_id: this.role._id,
        user_id: this.user._id,
      };
      this.$requests.delete('/v1/senior-funder-work-team', { params })
        .then(() => {
          this.display = false;
          this.$emit('success', this.role);
        })
        .catch(() => {
          this.$toast.error(
            `Unable to remove user from ${this.seniorFunderTitles[this.role.title]}...`,
            { timeout: 3000 },
          );
        })
        .then(() => { this.busy = false; });
    },
  },
  watch: {
    display(value) {
      if (!value) {
        this.role = null;
        this.user = null;
      }
    },
  },
};
</script>
